/**
 * Builds the URL to initiate oAuth authorization flow
 * for single-sign on (sso) integrations.
 *
 * @param {object} integration  The oAuth integration.
 *
 * @returns {string} result     The URL.
 */
const buildSingleSignOnURL = (integration) => {

	// Keep track of the original URL before redirection
	const originalURL = encodeURIComponent(window.location.href);

	// Redirect the user to the oAuth authorization endpoint
	return `/api/v2/oauth/integrations/${integration.id}/request-sso?original_url=${originalURL}`;

};

/**
 * Builds the URL to initiate oAuth authorization flow
 * for api integrations.
 *
 * @param {object} integration  The oAuth integration.
 *
 * @param {object} options                     Additional options for the URL.
 * @param {boolean} options.opened_in_new_tab  True, if the authorization flow
 *                                             happens in a new browser tab.
 *
 * @returns {string} result     The URL.
 */
const buildApiURL = (integration, options = {}) => {

	// Keep track of the original URL before redirection
	const originalURL = encodeURIComponent(window.location.href);

	let result =
		`/api/v2/oauth/integrations/${integration.id}/request-api?original_url=${originalURL}`;

	if (options.opened_in_new_tab) {
		result += '&opened_in_new_tab=true';
	}

	// Redirect the user to the oAuth authorization endpoint
	return result;

};

export {
	buildSingleSignOnURL,
	buildApiURL,
};
